import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Русский язык. 2 класс",
        subject: "Анализ состава слова как механизм развития словарного запаса",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Анализ состава слова как механизм развития словарного запаса",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Кузнецова Марина Ивановна",
                grade: "д.пед.н.",
                subGrade: "вед. научный сотрудник лаборатории начального общего образования ФГБНУ «Институт стратегии развития образования»",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>" +
                                "<p>Задача расширения словарного запаса младших школьников остаётся одной из самых актуальных задач обучения русскому языку. Особенно обострилась значимость нахождения эффективных путей решения этой задачи в современной ситуации. </p>" +
                                "<p>В кейсе рассматривается проблема расхождение между лексическими единицами словарного запаса младших школьников и лексическими единицами текстов, с которыми работают младшие школьники, рассогласование по наполняемости словаря школьника и лексического корпуса учебных текстов. Рассматривается также и ряд других проблем, связанных со словарным запасом младших школьников. </p>" +
                                "<p>Одним из способов уточнения и расширения словарного запаса является обучение школьников приемам развёрнутого толкования слова и осознанного анализа состава слова. Понимание связей между родственными словами, умение выделить в слове корень, в котором  сконцентрировано основное лексическое значение слова, часто помогает высказать предположение о значении незнакомого слова. Формирование навыка обращения к словарю как источнику проверки предположения также позитивно влияет на словарный запас младших школьников.  </p>" +
                                "<p>В кейсе анализируются наиболее частотные методические ошибки,  препятствующие осознанному освоению второклассниками  анализа состава слова, предлагаются пути преодоления этих ошибок. Работа с материалами кейса поможет педагогу осознать условия реализации значительного потенциала работы над составом слова в обогащении словарного запаса школьников, а также оценить эффективность собственной работы по формированию анализа состава слова. </p>" +
                                "</div>"
                        }
                    ]
                },
                {
                    type: "table",
                    title: "Учебый предмет",
                    text: "Русский язык"
                },
                {
                    type: "table",
                    title: "Класс",
                    text: "2"
                },
                {
                    type: "table",
                    title: "Тема",
                    subtitle: "(место в разделе)",
                    text: "«Анализ состава слова как механизм развития словарного запаса»\n" +
                        "Раздел «Состав слова (морфемика)»: корень как обязательная часть слова; однокоренные (родственные) слова; признаки однокоренных (родственных) слов; выделение в словах корня (простые случаи); суффикс как часть слова (наблюдение); приставка как часть слова (наблюдение)." +
                        "Раздел «Лексика»: лексическое значение слова (общее представление); выявление слов, значение которых требует уточнения \n"
                },
                {
                    type: "table",
                    title: "Цель кейса",
                    unorderedList: [
                        "проанализировать трудности овладения анализом состава слова в начальной школе, показать потенциал умения анализировать состав слова в расширении и уточнении словарного запаса; ",
                        "представить эффективные пути введения анализа состава слова в образовательный процесс во втором классе. "
                    ]
                },
                {
                    type: "table",
                    title: "Планируемые результаты",
                    subtitle: "(для педагога)",
                    unorderedList: [
                        "совершенствовать педагогическое мастерство учителя в организации работы по анализу второклассниками состава слова;",
                        "привлечь внимание педагога к приёму развёрнутого толкования слова как продуктивному способу работы над словарным запасом второклассников;",
                        "совершенствовать способность к педагогической рефлексии, позволяющей обнаружить связь методических просчетов при организации работы, направленной на анализ состава слова, и проблем младших школьников с пониманием слов  в читаемых текстах, с применением орфографических правил."
                    ]
                },
                {
                    type: "table",
                    title: "Планируемые результаты",
                    subtitle: "(для обучающихся)",
                    children: [
                        {
                            type: "table",
                            listLabel: "Личностные:",
                            unorderedList: [
                                "проявлять интерес к изучению состава слова, активность и самостоятельность в обнаружении слов, значение которых требуют уточнения;",
                                "осознавать правильную устную и письменную речью как показатель общей культуры;",
                                "осознавать важность расширения и уточнения собственного словарного запаса."
                            ]
                        },
                        {
                            type: "table",
                            listLabel: "Метапредметные:",
                            unorderedList: [
                                "сравнивать объекты  (находить сходство и различие лексического значения однокоренных (родственных) слов; выявлять случаи чередования в буквенной оболочке однокоренных (родственных) слов);",
                                "формулировать выводы и предлагать доказательства по обсуждаемой проблеме («слова являются/не являются однокоренными /родственными»).",
                            ]
                        },
                        {
                            type: "table",
                            listLabel: "Предметные:",
                            unorderedList: [
                                "находить однокоренные слова;",
                                "выделять в слове корень (простые случаи);",
                                "пользоваться толковым словарем учебника для уточнения значения слова;",
                                "давать развернутое толкование слова с использованием родственного слова;",
                                "уточнять по толковому словарю предположение о значении слова."
                            ]
                        },
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль. Часть 1",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4"
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль. Часть 2",
            htmlPath: "./interactive/dist2/index.html",
            autoHeight: false
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Федеральный государственный образовательный стандарт начального общего образования, утвержден Приказом Министерства просвещения Российской Федерации от 31 мая 2021 г. № 286",
                "Федеральная образовательная программа начального общего образования, утверждена Приказом Министерства просвещения России от 16.11.2022 N 992, зарегистрировано в Минюсте России 22.12.2022 N 71762.",
                "Федеральная рабочая программа начального общего образования предмета «Русский язык»",
                "Беседы с учителем: Второй класс четырехлетней начальной школы / Под ред. Л.Е. Журовой. – М.: Вентана - Графф, 2018. – 320 с",
                "Иванов С.В., Евдокимова А.О., Кузнецова М.И., Петленко Л.В., Романова В.Ю. Русский язык. 2 класс. Изд-во «Просвещение»",
                "Русский язык в начальных классах: теория и практика обучения. Под редакцией М.С. Соловейчик. М. Просвещение, 1993 г. 383 с.",
            ],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Дополнительные задания, которые помогают реализовать потенциал анализа состава слов в обогащении словарного запаса"
                }
            ]
        }
    ],
};
